<div class="flex flex-column gap-2 my-3">
    <label for="traitementPropose">Traitement proposé</label>
    <textarea pInputTextarea id="traitementPropose" [(ngModel)]="nonConformite.traitementPropose"
        [readOnly]="modeConsultation()" rows="5" style="resize: vertical;"></textarea>
</div>

<div class="flex flex-column gap-2 my-3">
    <label for="echeancier">Echéancier</label>
    <p-calendar *ngIf="!modeConsultation()" [(ngModel)]="nonConformite.echeancier" dateFormat="yy-mm-dd"
        [showIcon]="true" [minDate]="minDate"></p-calendar>
    <input *ngIf="modeConsultation()" id="echeancier" type="text" pInputText
        value="{{nonConformite.echeancier | date:'yyyy-MM-dd'}}" [readOnly]="true">
</div>

<div class="flex flex-column gap-2 my-3">
    <label for="dossierSst">Dossier SST</label>
    <input id="dossierSst" pInputText [(ngModel)]="nonConformite.dossierSst" [readonly]="modeConsultation()">
</div>

<div class="flex flex-column gap-2 my-3">
    <p-message *ngIf="modeModification()" severity="info" text="Pour ajouter des documents, veuillez naviguer vers la page des documents." />

    <p-button *ngIf="modeConsultation()" icon="pi pi-eye" label="Voir les documents"
        (click)="onViewDocuments.emit()"></p-button>
</div>

<div class="flex gap-3 flex-wrap my-4">
    <div class="flex flex-column gap-2">
        <label for="montant" style="width: fit-content;">Montant Hamel</label>
        <p-inputNumber [(ngModel)]="nonConformite.monetaireHamel" inputId="locale-user" [minFractionDigits]="2"
            [readonly]="modeConsultation()" suffix="$" min="0" />
    </div>

    <div class="flex flex-column gap-2">
        <label for="modeEstimation">Type de coût</label>
        <p-selectButton [options]="optionsMode" [(ngModel)]="nonConformite.modeEstimationHamel"
            [disabled]="modeConsultation() || nonConformite.monetaireHamel == null" />
        <small
            *ngIf="nonConformite.modeEstimationHamel != null && nonConformite.monetaireHamel == null && submitted">Veuillez
            entrer un montant Hamel</small>
    </div>
</div>

<div class="flex gap-3 flex-wrap my-4">
    <div class="flex flex-column gap-2">
        <label for="montant" style="width: fit-content;">Montant sous-traitance</label>
        <p-inputNumber [(ngModel)]="nonConformite.monetaire" inputId="locale-user" [minFractionDigits]="2"
            [readonly]="modeConsultation()" suffix="$" min="0" />
    </div>

    <div class="flex flex-column gap-2">
        <label for="modeEstimation">Type de coût</label>
        <p-selectButton [options]="optionsMode" [(ngModel)]="nonConformite.modeEstimation"
            [disabled]="modeConsultation() || nonConformite.monetaire == null" />
        <small *ngIf="nonConformite.modeEstimation != null && nonConformite.monetaire == null && submitted">Veuillez
            entrer un montant</small>
    </div>
</div>

<p-divider align="center" styleClass="my-3">
    <b>Approbation</b>
</p-divider>

<div class="flex flex-wrap gap-6 my-2">
    <div class="flex align-items-center">
        <p-radioButton name="approbation" value="Approuvé" [(ngModel)]="nonConformite.approbation"
            inputId="approbation1" [disabled]="modeConsultation()" />
        <label for="approbation1" class="ml-2">
            Approuvé
        </label>
    </div>

    <div class="flex align-items-center">
        <p-radioButton name="approbation" value="Rejeté" [(ngModel)]="nonConformite.approbation" inputId="approbation2"
            [disabled]="modeConsultation()" />
        <label for="approbation2" class="ml-2">
            Rejeté
        </label>
    </div>

    <div class="flex align-items-center">
        <p-radioButton name="approbation" value="Approuvé sous conditions" [(ngModel)]="nonConformite.approbation"
            inputId="approbation3" [disabled]="modeConsultation()" />
        <label for="approbation3" class="ml-2">
            Approuvé sous conditions
            <input *ngIf="nonConformite.approbation === 'Approuvé sous conditions'" type="text" class="ml-2" pInputText
                [(ngModel)]="nonConformite.approbationConditions" [readonly]="modeConsultation()"
                placeholder="Entrez les conditions" />
        </label>
    </div>

    <div class="flex align-items-center">
        <p-radioButton name="approbation" value="Autre" [(ngModel)]="nonConformite.approbation" inputId="approbation4"
            [disabled]="modeConsultation()" />
        <label for="approbation4" class="ml-2">
            Autre: <input *ngIf="nonConformite.approbation === 'Autre'" type="text" class="ml-2" pInputText
                [(ngModel)]="approbationAutre" [readonly]="modeConsultation()" />
        </label>
    </div>
</div>
<div *ngIf="modePopup" class="text-right mt-6">
    <button pButton pRipple label="Confirmer" icon="pi pi-check" class="p-button-primary"
        (click)="valider()" [loading]="submitting"></button>
</div>